import Parse from "../parse";
import { insert, update } from "./parseDB";

const TABLE = "spyx_Survey";
const SURVEY_ID_KEY = "survey_object_id";

/* =========================
   Pointer 헬퍼
========================= */
const toPointer = (className, objectId) => {
  const Obj = Parse.Object.extend(className);

  const pointer = new Obj();
  pointer.id = objectId;

  return pointer;
};

/* =========================
   값 직렬화
   배열은 String 컬럼 대응용 JSON 저장
========================= */
const serialize = (value) =>
  Array.isArray(value) ? JSON.stringify(value) : value;

/* =========================
   Survey 생성
========================= */
export const createSurvey = async (playerObjectId, colKey, colValue) => {
  const result = await insert(TABLE, {
    player: toPointer("spyx", playerObjectId),
    [colKey]: serialize(colValue),
  });

  localStorage.setItem(SURVEY_ID_KEY, result._id);

  return result._id;
};

/* =========================
   Survey 업데이트
========================= */
export const updateSurvey = async (colKey, colValue) => {
  const surveyId = localStorage.getItem(SURVEY_ID_KEY);

  if (!surveyId) {
    console.error("[updateSurvey] surveyId 없음");
    return false;
  }

  return await update(TABLE, surveyId, {
    [colKey]: serialize(colValue),
  });
};

/* =========================
   제출 완료 후 정리
========================= */
export const clearSurveyStorage = () => {
  localStorage.removeItem(SURVEY_ID_KEY);
};

export const getSurveyId = () => localStorage.getItem(SURVEY_ID_KEY);

/* =========================
설문 참여 여부 확인
========================= */
export const hasSurveyRow = async (playerObjectId) => {
  try {
    if (!playerObjectId) return false;

    const playerPointer = new Parse.Object("spyx");
    playerPointer.id = playerObjectId;

    const query = new Parse.Query(TABLE);

    query.equalTo("player", playerPointer);

    const result = await query.first();

    return !!result;
  } catch (error) {
    console.error("[hasSurveyRow] 실패", error);
    return false;
  }
};
